module.exports = {
	"v": "5.0.5",
	"fr": 30,
	"ip": 0,
	"op": 60,
	"w": 560,
	"h": 470,
	"nm": "Customer_ExperianceExpanded",
	"ddd": 0,
	"assets": [
		{
			"id": "image_0",
			"w": 235,
			"h": 125,
			"u": "https://cdn.auth0.com/website/financial-services/images/customer-experience/",
			"p": "img_0_1_1.png"
		},
		{
			"id": "image_1",
			"w": 440,
			"h": 501,
			"u": "https://cdn.auth0.com/website/financial-services/images/customer-experience/",
			"p": "img_1_1.png"
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 2,
			"ty": 2,
			"nm": "stars",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 33,
							"s": [
								0
							],
							"e": [
								100
							]
						},
						{
							"t": 39
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						128.484,
						146.917,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						117,
						62.5,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "toggle Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.4
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"n": [
								"0p4_1_0p333_0"
							],
							"t": 9,
							"s": [
								93
							],
							"e": [
								0
							]
						},
						{
							"t": 39.2470703125
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						306.218,
						186.393,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						-131.525,
						-128.905,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.686,
											-1.826
										],
										[
											0,
											0
										],
										[
											1.825,
											1.685
										],
										[
											0,
											0
										],
										[
											-1.685,
											1.826
										],
										[
											-1.826,
											-1.686
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.686,
											1.826
										],
										[
											0,
											0
										],
										[
											-1.826,
											-1.685
										],
										[
											1.687,
											-1.826
										],
										[
											0,
											0
										],
										[
											1.826,
											1.686
										]
									],
									"v": [
										[
											7.715,
											7.123
										],
										[
											7.715,
											7.123
										],
										[
											1.357,
											7.377
										],
										[
											-7.462,
											-0.764
										],
										[
											-7.715,
											-7.122
										],
										[
											-1.355,
											-7.376
										],
										[
											7.46,
											0.764
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-447.393,
													145.391
												],
												[
													112.607,
													145.391
												],
												[
													112.607,
													-324.609
												],
												[
													-447.393,
													-324.609
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-447.393,
													-324.609
												],
												[
													112.607,
													-324.609
												],
												[
													112.607,
													145.391
												],
												[
													-447.393,
													145.391
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.282000014361,
									0.564999988032,
									0.885999971278,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									9.65,
									9.312
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 2,
			"nm": "Layer 1",
			"refId": "image_1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						306.393,
						292.263,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						219.721,
						250.403,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/financial-services/animations/customer-experience/data.json
// module id = 1383
// module chunks = 0